import { render, staticRenderFns } from "./TypeWellRoman.vue?vue&type=template&id=406b6786&scoped=true"
import script from "./TypeWellRoman.vue?vue&type=script&lang=ts"
export * from "./TypeWellRoman.vue?vue&type=script&lang=ts"
import style0 from "./TypeWellRoman.vue?vue&type=style&index=0&id=406b6786&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b6786",
  null
  
)

export default component.exports